export const SET_DOCUMENT_TYPES = 'SET_DOCUMENT_TYPES'
export const ADD_DOCUMENT_TYPE = 'ADD_DOCUMENT_TYPE'
export const UPDATE_DOCUMENT_TYPE = 'UPDATE_DOCUMENT_TYPE'
export const DELETE_DOCUMENT_TYPE = 'DELETE_DOCUMENT_TYPE'
